import React, { useState } from "react";
import { FormikType } from "../../types/types";
import { InitialAuditionStateType } from "../../assets/data/initialState";
import { CustomButton, LocationTagFilterModal } from "../Components";

export type Props = FormikType<InitialAuditionStateType>;

export default function LocationTagFilter({ formik }: Props) {
  const [isLocationTagFilterModalVisible, setIsLocationTagFilterModalVisible] =
    useState<boolean>(false);

  return (
    <div className="mb-8">
      <LocationTagFilterModal
        formik={formik}
        isOpen={isLocationTagFilterModalVisible}
        closeModal={() => setIsLocationTagFilterModalVisible(false)}
      />
      <p className="font-Switzer font-bold text-2xl tracking-tight mb-1">
        Location Tag
      </p>
      <p className="font-Switzer text-base tracking-tight mb-2">
        Set a location for this audition.
      </p>
      <div className="flex flex-row space-x-2 overflow-x-auto scrollbar-hide">
        <CustomButton
          text="Edit"
          className="medium-green-button"
          onClick={() => setIsLocationTagFilterModalVisible(true)}
        />
        {formik.values.locationTagFilters &&
          formik.values.locationTagFilters.map((lt, i) => (
            <CustomButton
              key={i}
              text={lt.title}
              className="medium-white-button-no-hover"
            />
          ))}
      </div>
    </div>
  );
}
